export default "__VITE_ASSET__BijvW8zA__"